export enum ToastType {
  SUCCESS = 'success',
  ALERT = 'warning',
  DANGER = 'danger',
  INFO = 'info'
}
